import styles from '../index.module.css'

import cn from 'clsx'
import React, { useRef } from 'react'

import type { PlaylistCurated } from 'types/playlist'

import { Card, Flex, Text } from 'components/ds'
import AspectRatio from 'components/ui/aspect-ratio'

import { useOptimizedImage } from 'hooks/use-optimized-image'

type PlaylistCardProps = {
  index: number
  playlist: PlaylistCurated
  isHovered: number | null
  onHover: (_index: number | null) => void
  onClick?: () => void
}

const colorClasses = [
  'var(--disco-yellow)',
  'var(--disco-pop)',
  'var(--disco-techno)',
  'var(--disco-soul)',
  'var(--disco-latin)',
]

const IMAGE_PARAMS = { w: 770, h: 448, fit: 'cover' }

export const PlaylistCard = ({
  playlist,
  index,
  isHovered,
  onHover,
  onClick,
}: PlaylistCardProps) => {
  const imageContainerRef = useRef<HTMLDivElement>(null)
  const optimizedImageUrl = useOptimizedImage({
    image: playlist?.image,
    containerRef: imageContainerRef,
    params: IMAGE_PARAMS,
  })

  return (
    <Card
      ref={imageContainerRef}
      variant="classic"
      className={cn(styles.PlaylistCard_Card, {
        [styles.PlaylistCard_Clickable]: !!onClick,
      })}
      onMouseEnter={() => onHover(index)}
      onMouseLeave={() => onHover(null)}
      onClick={onClick}
    >
      {isHovered === index && (
        <div className={styles.PlaylistCard_PlayButtonContainer} />
      )}
      <AspectRatio
        image={optimizedImageUrl}
        ratio={1.725}
        shape="square"
        fill={colorClasses[index % colorClasses.length]}
      >
        {playlist.image ? null : (
          <Flex
            direction="column"
            p="2"
            height="95%"
            align="center"
            width="95%"
            justify="center"
          >
            <Flex className={cn(styles.PlaylistCard_ImagePlaceholder)}>
              <Text
                as="p"
                weight="bold"
                size={{
                  initial: '4',
                  md: '8',
                  lg: '9',
                  xl: '9',
                }}
                className={cn(styles.Text)}
                wrap="balance"
                trim="both"
                highContrast
              >
                {playlist.name}
              </Text>
            </Flex>
          </Flex>
        )}
      </AspectRatio>
    </Card>
  )
}
